import colors from '../colors';
export var MuiCheckbox = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            width: '16px',
            height: '16px',
            padding: '8px',
            color: colors.grey[800],
            ':hover': {
                color: colors.blue[500],
            },
            '&.Mui-checked:hover': {
                color: colors.blue[300],
            },
        },
    },
};
